<template>
  <div :id="chart_id" />
</template>

<script>
import Highcharts from "highcharts/highcharts.js";
import Drilldown from "highcharts/modules/drilldown.js";
Drilldown(Highcharts);
import exportingInit from "highcharts/modules/exporting";
exportingInit(Highcharts);

export default {
  name: "dynamic_chart",
  props: {
    chart_id: {
      type: String,
      default: "medmon-chart",
    },
    config: Object,
  },
  methods: {
    loadChart: function () {
      let el = this.chart_id;
      let config = this.config;
      new Highcharts.chart(el, config);
    },
  },
  mounted: function () {
    if (this.config) {
      this.loadChart();
    }
  },
};
</script>